import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EmailOpenIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "EmailOpen",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M5.5 28.51h21.02c1.92 0 3.48-1.56 3.48-3.48V13.97c0-1.43-.86-2.65-2.09-3.19h-.02l-9.9-6.68c-.55-.38-1.23-.61-1.97-.61s-1.42.23-1.98.62h.01l-9.88 6.67A3.48 3.48 0 0 0 2.01 14v11.04c0 1.92 1.56 3.48 3.48 3.48h.03ZM16.59 6.67l10.01 7.01c.26.18.43.48.43.82 0 .28-.12.53-.3.72l-4.55 4.42 3.48 3.11a1.003 1.003 0 0 1-.56 1.83c-.3 0-.56-.13-.74-.33s-.87-.75-.87-.75l-6.15-5.49c-.35-.31-.82-.51-1.33-.51s-.98.19-1.33.51-1.54 1.37-1.54 1.37l-4.63 4.11-.87.75c-.18.16-.41.25-.67.25-.55 0-1-.45-1-1 0-.3.13-.56.33-.75s3.48-3.11 3.48-3.11L5.29 15.2a.99.99 0 0 1-.3-.72c0-.34.17-.64.43-.82s2.4-1.68 2.4-1.68l2.15-1.5 1.55-1.09 3.91-2.74c.16-.11.36-.18.57-.18s.41.07.58.18Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M27 28H5c-1.65 0-3-1.35-3-3V12.65c0-1.11.6-2.12 1.58-2.64L13.63 4.6c1.49-.8 3.26-.8 4.74 0l10.05 5.41c.97.52 1.58 1.54 1.58 2.64V25c0 1.65-1.35 3-3 3M16 6c-.49 0-.98.12-1.42.36L4.53 11.77c-.32.17-.53.51-.53.88V25c0 .55.45 1 1 1h22c.55 0 1-.45 1-1V12.65c0-.37-.2-.71-.53-.88L17.42 6.36C16.97 6.12 16.49 6 16 6"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16 20a1 1 0 0 1-.55-.17l-7.5-5a1.001 1.001 0 1 1 1.11-1.67l6.95 4.63 6.95-4.63a1.001 1.001 0 1 1 1.11 1.67l-7.5 5c-.17.11-.36.17-.55.17Z"
      })]
    })
  }));
};